module.exports = __webpack_public_path__ + "static/media/brushmmkn.5b59bcad.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/brushmmkn.png
// module id = 83
// module chunks = 0